// extracted by mini-css-extract-plugin
export default {"landingPageLayout":"kMCCZG2xdGqiNINT2MQZ"};